import { useOfferApi } from './useOfferApi';
import { useOfferGetters } from './useOfferGetters';
import { useOfferHelpers } from './useOfferHelpers';

import type { UseOffer } from './types';
export function useOffer(): UseOffer {
  return {
    ...useOfferApi(),
    ...useOfferGetters(),
    ...useOfferHelpers(),
  };
}
